/**
 * Helpers for numbers that span both Openings businesses. The same person has
 * a separate record in Eddie's Edition and Edition Studio, so a combined
 * figure is built from one read per business.
 */

/**
 * Sum one count per business. Returns `null` when any count is missing or is
 * not a non-negative safe integer: a partial sum must never be shown as if it
 * were the total.
 */
export const sumCounts = (
  counts: readonly (number | null | undefined)[],
): number | null => {
  let total = 0;
  for (const count of counts) {
    if (typeof count !== "number" || !Number.isSafeInteger(count) || count < 0) {
      return null;
    }
    total += count;
  }
  return Number.isSafeInteger(total) ? total : null;
};
